import { extendTheme, theme as baseTheme } from "@chakra-ui/react";
import * as components from "./components/index.js";
import * as foundations from "./foundations/index.js";

export const theme: Record<string, any> = extendTheme({
  ...foundations,
  components: { ...components },
  colors: { ...baseTheme.colors, brand: baseTheme.colors.blue },
  space: {
    "4.5": "1.125rem",
  },
});
